export default __webpack_public_path__ + "static/media/testbanner.965a9b86.png";